import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../index"

const ProgramGroup = ({ blok }) => (
  <SbEditable content={blok}>
    <div>
      {blok.black_title_color === true ? (
        <p className={`program-group-title black`}>{blok.title}</p>
      ) : (
        <p className={`program-group-title white`}>{blok.title}</p>
      )}
    </div>
    <div className={`program-group`}>
      {blok.programs &&
        blok.programs.map((content) =>
          React.createElement(Components(content.component), {
            key: content._uid,
            blok: content,
            className: "program-group__program",
          })
        )}
    </div>
  </SbEditable>
)

ProgramGroup.propTypes = {
  blok: PropTypes.shape({}).isRequired,
}

export default ProgramGroup
